// extracted by mini-css-extract-plugin
export default {"Container":"BackgroundVideo_Container__wU97a","Video":"BackgroundVideo_Video__Rxqr7"};